// @ts-nocheck

import { createSelector } from 'reselect';

import { KLCollectibleStatuses } from '../../types/collectible';
import { selectKLUserBadge } from '../user';

const getBadgeIdFromProps = (_, { badgeId }) => badgeId ?? null;

const selectKLBadgeProps = createSelector([selectKLUserBadge, getBadgeIdFromProps], (badge, badgeId) => ({
  badgeId,
  status: badge?.status ?? KLCollectibleStatuses.OPEN,
}));

export default selectKLBadgeProps;
